import { marketsConfig } from '$lib/config/markets';

export function makePythQueryStringFromObject(obj: Record<string, Record<string, any>>) {
	let str = '';
	let index = 0;
	for (let key in obj) {
		if (str != '') {
			str += '&';
		}
		str += `ids[${index}]` + '=' + encodeURIComponent(obj[key].pythFeedKey);
		index++;
	}
	return str;
}

export function splitObjectIntoBatches(
	obj: Record<string, Record<string, any>>,
	batchSize: number
) {
	let batches: Array<Record<string, Record<string, any>>> = [];
	let batch: Record<string, Record<string, any>> = {};
	let index = 0;
	for (let key in obj) {
		if (index % batchSize == 0) {
			batch = {};
			batches.push(batch);
		}
		batch[key] = obj[key];
		index++;
	}
	return batches;
}

export function generateActiveMarketsConfig(
	marketsConfig: Record<string, Record<string, any>>
): Record<string, Record<string, any>> {
	let activeMarketsConfig: Record<string, Record<string, any>> = {};
	for (let key in marketsConfig) {
		if (marketsConfig[key].active) {
			activeMarketsConfig[key] = marketsConfig[key];
		}
	}
	return activeMarketsConfig;
}

export function generatePythFeedToMarket(marketsConfig: Record<string, Record<string, any>>) {
	let _pythFeedToMarket: Record<string, string[]> = {};
	for (let key in marketsConfig) {
		if (marketsConfig[key].active) {
			if (_pythFeedToMarket[marketsConfig[key].pythFeedKey]) {
				_pythFeedToMarket[marketsConfig[key].pythFeedKey].push(key);
			} else {
				_pythFeedToMarket[marketsConfig[key].pythFeedKey] = [key];
			}
		}
	}
	return _pythFeedToMarket;
}

export function generatePytFeedToMarketObject(pythFeedToMarket: Record<string, string[]>) {
	var ob: {
		[pythKey: string]: {
			[market: string]: boolean;
		};
	} = {};

	for (let key in pythFeedToMarket) {
		ob[key] = {};
		pythFeedToMarket[key].forEach((market) => {
			ob[key][market] = true;
		});
	}
	return ob;
}

export const activeMarketsConfig = generateActiveMarketsConfig(marketsConfig);
export const pythFeedToMarket = generatePythFeedToMarket(activeMarketsConfig);
export const pythFeedToMarketAsObject = generatePytFeedToMarketObject(pythFeedToMarket);

export const PYTH_FEED_BATCH_SIZE = 100;

export const marketsConfigBatches = splitObjectIntoBatches(
	activeMarketsConfig,
	PYTH_FEED_BATCH_SIZE
);
